export const adminStats = [
  {
    id: 1,
    title: "Total Users",
    value: "24,817",
    change: "+342 today",
    changeType: "positive",
    icon: "ri-user-line",
    sub: "2,104 KYC pending",
  },
  {
    id: 2,
    title: "24h Trade Volume",
    value: "₦1.84B",
    change: "+18.4%",
    changeType: "positive",
    icon: "ri-exchange-line",
    sub: "vs ₦1.55B yesterday",
  },
  {
    id: 3,
    title: "Total AUM",
    value: "₦12.6B",
    change: "+2.1%",
    changeType: "positive",
    icon: "ri-safe-line",
    sub: "Assets under management",
  },
  {
    id: 4,
    title: "Pending Withdrawals",
    value: "₦48.2M",
    change: "37 requests",
    changeType: "neutral",
    icon: "ri-time-line",
    sub: "Avg wait: 12 mins",
  },
  {
    id: 5,
    title: "Revenue (30d)",
    value: "₦94.3M",
    change: "+11.2%",
    changeType: "positive",
    icon: "ri-money-dollar-circle-line",
    sub: "Fees + spreads",
  },
  {
    id: 6,
    title: "Failed Transactions",
    value: "143",
    change: "-22% vs last week",
    changeType: "positive",
    icon: "ri-error-warning-line",
    sub: "Needs review: 12",
  },
];

export const volumeChartData = [
  { name: "Mon", buy: 280, sell: 190, deposit: 120, withdraw: 95 },
  { name: "Tue", buy: 340, sell: 220, deposit: 145, withdraw: 110 },
  { name: "Wed", buy: 310, sell: 260, deposit: 130, withdraw: 140 },
  { name: "Thu", buy: 420, sell: 300, deposit: 180, withdraw: 160 },
  { name: "Fri", buy: 510, sell: 380, deposit: 210, withdraw: 195 },
  { name: "Sat", buy: 460, sell: 340, deposit: 190, withdraw: 175 },
  { name: "Sun", buy: 390, sell: 280, deposit: 160, withdraw: 130 },
];

export const liveRates = [
  { id: 1, symbol: "BTC", name: "Bitcoin", price: "₦98,420,000", usd: "$64,280", change: "+2.4%", changeType: "positive", icon: "ri-bit-coin-line" },
  { id: 2, symbol: "ETH", name: "Ethereum", price: "₦5,210,000", usd: "$3,402", change: "+1.8%", changeType: "positive", icon: "ri-coin-line" },
  { id: 3, symbol: "USDT", name: "Tether", price: "₦1,530", usd: "$1.00", change: "0.0%", changeType: "neutral", icon: "ri-money-dollar-circle-line" },
  { id: 4, symbol: "BNB", name: "BNB", price: "₦870,000", usd: "$568", change: "-0.9%", changeType: "negative", icon: "ri-coin-line" },
  { id: 5, symbol: "SOL", name: "Solana", price: "₦228,000", usd: "$149", change: "+5.2%", changeType: "positive", icon: "ri-coin-line" },
  { id: 6, symbol: "XRP", name: "XRP", price: "₦84,000", usd: "$0.55", change: "-1.3%", changeType: "negative", icon: "ri-coin-line" },
];

export const recentTransactions = [
  { id: "TXN-00291", user: "Chukwuemeka Obi", type: "Buy", asset: "BTC", amount: "₦500,000", status: "completed", time: "2 min ago" },
  { id: "TXN-00290", user: "Amaka Nwosu", type: "Sell", asset: "ETH", amount: "₦1,200,000", status: "completed", time: "8 min ago" },
  { id: "TXN-00289", user: "Tunde Adeyemi", type: "Withdraw Naira", asset: "NGN", amount: "₦350,000", status: "pending", time: "15 min ago" },
  { id: "TXN-00288", user: "Ngozi Eze", type: "Deposit", asset: "USDT", amount: "₦765,000", status: "completed", time: "22 min ago" },
  { id: "TXN-00287", user: "Babatunde Lawal", type: "Buy", asset: "SOL", amount: "₦200,000", status: "failed", time: "31 min ago" },
  { id: "TXN-00286", user: "Chidinma Okafor", type: "Withdraw Crypto", asset: "BTC", amount: "₦2,100,000", status: "pending", time: "45 min ago" },
  { id: "TXN-00285", user: "Emeka Eze", type: "Sell", asset: "BNB", amount: "₦430,000", status: "completed", time: "1 hr ago" },
  { id: "TXN-00284", user: "Fatima Bello", type: "Buy", asset: "ETH", amount: "₦900,000", status: "completed", time: "1 hr ago" },
];

export const kycQueue = [
  {
    id: "USR-1042",
    name: "Adaeze Okonkwo",
    tier: "Tier 2",
    doc: "NIN + Selfie",
    submitted: "Today, 9:14 AM",
    status: "pending",
    email: "adaeze.o@gmail.com",
    phone: "+234 809 012 3456",
    dob: "14 Mar 1992",
    documents: [
      {
        label: "NIN Slip",
        type: "image",
        url: "https://readdy.ai/api/search-image?query=Nigerian%20NIN%20national%20identity%20number%20slip%20official%20government%20document%20with%20photo%20ID%20card%20front%20view%20clear%20scan%20high%20quality&width=800&height=500&seq=kyc_nin_adaeze&orientation=landscape",
      },
      {
        label: "Selfie with ID",
        type: "image",
        url: "https://readdy.ai/api/search-image?query=person%20holding%20national%20identity%20card%20selfie%20verification%20photo%20clear%20face%20visible%20Nigerian%20young%20woman%20professional%20plain%20background&width=600&height=700&seq=kyc_selfie_adaeze&orientation=portrait",
      },
    ],
  },
  {
    id: "USR-1041",
    name: "Seun Adesanya",
    tier: "Tier 3",
    doc: "Utility Bill",
    submitted: "Today, 8:52 AM",
    status: "pending",
    email: "seun.a@gmail.com",
    phone: "+234 810 123 4567",
    dob: "02 Jul 1988",
    documents: [
      {
        label: "Utility Bill (EKEDC)",
        type: "image",
        url: "https://readdy.ai/api/search-image?query=Nigerian%20electricity%20utility%20bill%20EKEDC%20official%20document%20showing%20address%20name%20account%20number%20clear%20scan%20printed%20paper&width=800&height=600&seq=kyc_utility_seun&orientation=landscape",
      },
      {
        label: "Bank Statement",
        type: "image",
        url: "https://readdy.ai/api/search-image?query=Nigerian%20bank%20statement%20official%20document%20GTBank%20showing%20transactions%20account%20holder%20name%20address%20printed%20formal&width=800&height=600&seq=kyc_bank_seun&orientation=landscape",
      },
    ],
  },
  {
    id: "USR-1040",
    name: "Kelechi Nwachukwu",
    tier: "Tier 2",
    doc: "BVN + Passport",
    submitted: "Today, 8:30 AM",
    status: "review",
    email: "kelechi.n@gmail.com",
    phone: "+234 811 234 5678",
    dob: "19 Nov 1995",
    documents: [
      {
        label: "International Passport",
        type: "image",
        url: "https://readdy.ai/api/search-image?query=Nigerian%20international%20passport%20data%20page%20official%20document%20photo%20biometric%20green%20cover%20open%20showing%20personal%20details%20clear%20scan&width=800&height=550&seq=kyc_passport_kelechi&orientation=landscape",
      },
      {
        label: "BVN Verification Screenshot",
        type: "image",
        url: "https://readdy.ai/api/search-image?query=BVN%20bank%20verification%20number%20Nigeria%20NIBSS%20confirmation%20screen%20showing%20name%20date%20of%20birth%20enrollment%20status%20digital&width=700&height=450&seq=kyc_bvn_kelechi&orientation=landscape",
      },
      {
        label: "Selfie with Passport",
        type: "image",
        url: "https://readdy.ai/api/search-image?query=person%20holding%20international%20passport%20selfie%20verification%20photo%20clear%20face%20visible%20Nigerian%20young%20man%20professional%20plain%20background&width=600&height=700&seq=kyc_selfie_kelechi&orientation=portrait",
      },
    ],
  },
  {
    id: "USR-1039",
    name: "Yetunde Olatunji",
    tier: "Tier 1",
    doc: "Phone Verification",
    submitted: "Today, 7:45 AM",
    status: "pending",
    email: "yetunde.o@gmail.com",
    phone: "+234 812 345 6789",
    dob: "28 Jun 1997",
    documents: [
      {
        label: "Phone OTP Screenshot",
        type: "image",
        url: "https://readdy.ai/api/search-image?query=mobile%20phone%20SMS%20OTP%20verification%20code%20message%20screenshot%20Nigerian%20phone%20number%20verification%20app%20confirmation%20screen&width=600&height=400&seq=kyc_phone_yetunde&orientation=landscape",
      },
    ],
  },
  {
    id: "USR-1038",
    name: "Obinna Igwe",
    tier: "Tier 3",
    doc: "CAC Document",
    submitted: "Yesterday",
    status: "review",
    email: "obinna.igwe@gmail.com",
    phone: "+234 806 789 0123",
    dob: "05 Feb 1984",
    documents: [
      {
        label: "CAC Certificate of Incorporation",
        type: "image",
        url: "https://readdy.ai/api/search-image?query=CAC%20Corporate%20Affairs%20Commission%20Nigeria%20certificate%20of%20incorporation%20official%20document%20company%20registration%20seal%20stamp%20formal&width=800&height=600&seq=kyc_cac_obinna&orientation=landscape",
      },
      {
        label: "Director ID (NIN)",
        type: "image",
        url: "https://readdy.ai/api/search-image?query=Nigerian%20NIN%20national%20identity%20number%20slip%20official%20government%20document%20with%20photo%20ID%20card%20front%20view%20clear%20scan%20business%20director&width=800&height=500&seq=kyc_nin_obinna&orientation=landscape",
      },
    ],
  },
];

export const allTransactions = [
  { id: "TXN-00291", user: "Chukwuemeka Obi", userId: "USR-1050", type: "Buy", asset: "BTC", naira: "₦500,000", crypto: "0.00508 BTC", fee: "₦2,500", status: "completed", time: "Today, 10:02 AM", paymentMethod: "Paystack" },
  { id: "TXN-00290", user: "Amaka Nwosu", userId: "USR-1049", type: "Sell", asset: "ETH", naira: "₦1,200,000", crypto: "0.23 ETH", fee: "₦6,000", status: "completed", time: "Today, 9:54 AM", paymentMethod: "Bank Transfer" },
  { id: "TXN-00289", user: "Tunde Adeyemi", userId: "USR-1048", type: "Withdraw Naira", asset: "NGN", naira: "₦350,000", crypto: "—", fee: "₦100", status: "pending", time: "Today, 9:45 AM", paymentMethod: "GTBank — 0123456789" },
  { id: "TXN-00288", user: "Ngozi Eze", userId: "USR-1046", type: "Deposit", asset: "USDT", naira: "₦765,000", crypto: "500 USDT", fee: "₦0", status: "completed", time: "Today, 9:38 AM", paymentMethod: "On-chain (TRC20)" },
  { id: "TXN-00287", user: "Babatunde Lawal", userId: "USR-1047", type: "Buy", asset: "SOL", naira: "₦200,000", crypto: "0.877 SOL", fee: "₦1,000", status: "failed", time: "Today, 9:29 AM", paymentMethod: "Paystack" },
  { id: "TXN-00286", user: "Chidinma Okafor", userId: "USR-1050", type: "Withdraw Crypto", asset: "BTC", naira: "₦2,100,000", crypto: "0.02134 BTC", fee: "₦5,000", status: "pending", time: "Today, 9:15 AM", paymentMethod: "External Wallet" },
  { id: "TXN-00285", user: "Emeka Eze", userId: "USR-1049", type: "Sell", asset: "BNB", naira: "₦430,000", crypto: "0.494 BNB", fee: "₦2,150", status: "completed", time: "Today, 8:50 AM", paymentMethod: "Bank Transfer" },
  { id: "TXN-00284", user: "Fatima Bello", userId: "USR-1048", type: "Buy", asset: "ETH", naira: "₦900,000", crypto: "0.1727 ETH", fee: "₦4,500", status: "completed", time: "Today, 8:30 AM", paymentMethod: "Paystack" },
  { id: "TXN-00283", user: "Seun Adesanya", userId: "USR-1046", type: "Deposit", asset: "BTC", naira: "₦4,920,000", crypto: "0.05 BTC", fee: "₦0", status: "completed", time: "Yesterday, 11:20 PM", paymentMethod: "On-chain (BTC)" },
  { id: "TXN-00282", user: "Adaeze Okonkwo", userId: "USR-1047", type: "Withdraw Naira", asset: "NGN", naira: "₦1,500,000", crypto: "—", fee: "₦100", status: "failed", time: "Yesterday, 9:10 PM", paymentMethod: "Zenith — 9876543210" },
  { id: "TXN-00281", user: "Kelechi Nwachukwu", userId: "USR-1050", type: "Buy", asset: "USDT", naira: "₦306,000", crypto: "200 USDT", fee: "₦1,530", status: "completed", time: "Yesterday, 6:45 PM", paymentMethod: "Paystack" },
  { id: "TXN-00280", user: "Yetunde Olatunji", userId: "USR-1049", type: "Sell", asset: "SOL", naira: "₦684,000", crypto: "3 SOL", fee: "₦3,420", status: "completed", time: "Yesterday, 4:20 PM", paymentMethod: "Bank Transfer" },
];

export const allUsers = [
  { id: "USR-1050", name: "Chiamaka Eze", email: "chiamaka@gmail.com", phone: "+234 801 234 5678", kyc: "Tier 2", balance: "₦1,240,000", joined: "Apr 27, 2026", status: "active", txCount: 14, referrals: 3 },
  { id: "USR-1049", name: "Rotimi Adebayo", email: "rotimi@yahoo.com", phone: "+234 802 345 6789", kyc: "Tier 1", balance: "₦85,000", joined: "Apr 27, 2026", status: "active", txCount: 2, referrals: 0 },
  { id: "USR-1048", name: "Blessing Obi", email: "blessing.obi@gmail.com", phone: "+234 803 456 7890", kyc: "Tier 3", balance: "₦8,400,000", joined: "Apr 26, 2026", status: "active", txCount: 47, referrals: 12 },
  { id: "USR-1047", name: "Uche Nwosu", email: "uche.n@outlook.com", phone: "+234 804 567 8901", kyc: "Tier 0", balance: "₦0", joined: "Apr 26, 2026", status: "suspended", txCount: 0, referrals: 0 },
  { id: "USR-1046", name: "Aisha Musa", email: "aisha.musa@gmail.com", phone: "+234 805 678 9012", kyc: "Tier 2", balance: "₦3,100,000", joined: "Apr 25, 2026", status: "active", txCount: 28, referrals: 7 },
  { id: "USR-1045", name: "Obinna Igwe", email: "obinna.igwe@gmail.com", phone: "+234 806 789 0123", kyc: "Tier 3", balance: "₦15,800,000", joined: "Apr 24, 2026", status: "active", txCount: 93, referrals: 21 },
  { id: "USR-1044", name: "Ngozi Eze", email: "ngozi.eze@gmail.com", phone: "+234 807 890 1234", kyc: "Tier 2", balance: "₦2,750,000", joined: "Apr 23, 2026", status: "active", txCount: 19, referrals: 4 },
  { id: "USR-1043", name: "Tunde Adeyemi", email: "tunde.a@gmail.com", phone: "+234 808 901 2345", kyc: "Tier 1", balance: "₦420,000", joined: "Apr 22, 2026", status: "active", txCount: 6, referrals: 1 },
  { id: "USR-1042", name: "Adaeze Okonkwo", email: "adaeze.o@gmail.com", phone: "+234 809 012 3456", kyc: "Tier 2", balance: "₦980,000", joined: "Apr 21, 2026", status: "active", txCount: 11, referrals: 2 },
  { id: "USR-1041", name: "Seun Adesanya", email: "seun.a@gmail.com", phone: "+234 810 123 4567", kyc: "Tier 3", balance: "₦22,100,000", joined: "Apr 20, 2026", status: "active", txCount: 134, referrals: 38 },
];

export const withdrawalRequests = [
  { id: "WD-0091", user: "Tunde Adeyemi", userId: "USR-1043", type: "Naira", amount: "₦350,000", bank: "GTBank", account: "0123456789", accountName: "Tunde Adeyemi", requested: "Today, 9:45 AM", status: "pending" },
  { id: "WD-0090", user: "Chidinma Okafor", userId: "USR-1044", type: "Crypto", amount: "0.02134 BTC", bank: "—", account: "bc1qxy2kgdygjrsqtzq2n0yrf2493p83kkfjhx0wlh", accountName: "External Wallet", requested: "Today, 9:15 AM", status: "pending" },
  { id: "WD-0089", user: "Yetunde Olatunji", userId: "USR-1039", type: "Naira", amount: "₦1,200,000", bank: "Access Bank", account: "0987654321", accountName: "Yetunde Olatunji", requested: "Today, 8:30 AM", status: "pending" },
  { id: "WD-0088", user: "Kelechi Nwachukwu", userId: "USR-1040", type: "Crypto", amount: "150 USDT", bank: "—", account: "TRx8kLmN9pQrStUvWxYz1234567890abcdef", accountName: "External Wallet", requested: "Today, 7:55 AM", status: "review" },
  { id: "WD-0087", user: "Rotimi Adebayo", userId: "USR-1049", type: "Naira", amount: "₦75,000", bank: "First Bank", account: "3012345678", accountName: "Rotimi Adebayo", requested: "Today, 7:20 AM", status: "pending" },
  { id: "WD-0086", user: "Fatima Bello", userId: "USR-1048", type: "Naira", amount: "₦2,500,000", bank: "Zenith Bank", account: "2109876543", accountName: "Fatima Bello", requested: "Yesterday, 11:40 PM", status: "review" },
  { id: "WD-0085", user: "Obinna Igwe", userId: "USR-1045", type: "Crypto", amount: "0.5 ETH", bank: "—", account: "0x742d35Cc6634C0532925a3b844Bc454e4438f44e", accountName: "External Wallet", requested: "Yesterday, 10:15 PM", status: "pending" },
  { id: "WD-0084", user: "Aisha Musa", userId: "USR-1046", type: "Naira", amount: "₦800,000", bank: "UBA", account: "1234567890", accountName: "Aisha Musa", requested: "Yesterday, 8:00 PM", status: "pending" },
];

export const assetsData = [
  { id: 1, symbol: "BTC", name: "Bitcoin", price: "₦98,420,000", usd: "$64,280", change: "+2.4%", changeType: "positive", spread: "1.5%", minBuy: "₦1,000", maxBuy: "₦50,000,000", networks: ["BTC"], totalHeld: "4.821 BTC", aum: "₦474.5M", status: "active" },
  { id: 2, symbol: "ETH", name: "Ethereum", price: "₦5,210,000", usd: "$3,402", change: "+1.8%", changeType: "positive", spread: "1.5%", minBuy: "₦1,000", maxBuy: "₦50,000,000", networks: ["ERC20"], totalHeld: "142.3 ETH", aum: "₦741.4M", status: "active" },
  { id: 3, symbol: "USDT", name: "Tether", price: "₦1,530", usd: "$1.00", change: "0.0%", changeType: "neutral", spread: "0.8%", minBuy: "₦1,000", maxBuy: "₦100,000,000", networks: ["ERC20", "TRC20", "BEP20"], totalHeld: "2,841,200 USDT", aum: "₦4.35B", status: "active" },
  { id: 4, symbol: "BNB", name: "BNB", price: "₦870,000", usd: "$568", change: "-0.9%", changeType: "negative", spread: "1.5%", minBuy: "₦1,000", maxBuy: "₦20,000,000", networks: ["BEP20"], totalHeld: "891.4 BNB", aum: "₦775.5M", status: "active" },
  { id: 5, symbol: "SOL", name: "Solana", price: "₦228,000", usd: "$149", change: "+5.2%", changeType: "positive", spread: "1.5%", minBuy: "₦1,000", maxBuy: "₦20,000,000", networks: ["SOL"], totalHeld: "3,204 SOL", aum: "₦730.5M", status: "active" },
  { id: 6, symbol: "XRP", name: "XRP", price: "₦84,000", usd: "$0.55", change: "-1.3%", changeType: "negative", spread: "1.5%", minBuy: "₦1,000", maxBuy: "₦20,000,000", networks: ["XRP"], totalHeld: "48,200 XRP", aum: "₦4.05B", status: "active" },
];

export const walletsData = [
  { id: 1, asset: "BTC", network: "Bitcoin", address: "bc1qxy2kgdygjrsqtzq2n0yrf2493p83kkfjhx0wlh", balance: "4.821 BTC", nairaValue: "₦474.5M", lastActivity: "2 min ago", status: "active" },
  { id: 2, asset: "ETH", network: "Ethereum (ERC20)", address: "0x742d35Cc6634C0532925a3b844Bc454e4438f44e", balance: "142.3 ETH", nairaValue: "₦741.4M", lastActivity: "8 min ago", status: "active" },
  { id: 3, asset: "USDT", network: "Tron (TRC20)", address: "TRx8kLmN9pQrStUvWxYz1234567890abcdef", balance: "1,420,600 USDT", nairaValue: "₦2.17B", lastActivity: "22 min ago", status: "active" },
  { id: 4, asset: "USDT", network: "Ethereum (ERC20)", address: "0x8Ba1f109551bD432803012645Ac136ddd64DBA72", balance: "1,420,600 USDT", nairaValue: "₦2.17B", lastActivity: "1 hr ago", status: "active" },
  { id: 5, asset: "BNB", network: "BNB Smart Chain", address: "0x1234567890abcdef1234567890abcdef12345678", balance: "891.4 BNB", nairaValue: "₦775.5M", lastActivity: "3 hr ago", status: "active" },
  { id: 6, asset: "SOL", network: "Solana", address: "7EcDhSYGxXyscszYEp35KHN8vvw3svAuLKTzXwCFLtV", balance: "3,204 SOL", nairaValue: "₦730.5M", lastActivity: "5 hr ago", status: "active" },
];

export const revenueData = [
  { month: "Jan", fees: 4200000, spread: 6800000, total: 11000000 },
  { month: "Feb", fees: 5100000, spread: 8200000, total: 13300000 },
  { month: "Mar", fees: 4800000, spread: 7600000, total: 12400000 },
  { month: "Apr", fees: 6200000, spread: 9800000, total: 16000000 },
  { month: "May", fees: 7100000, spread: 11200000, total: 18300000 },
  { month: "Jun", fees: 8400000, spread: 13100000, total: 21500000 },
  { month: "Jul", fees: 7800000, spread: 12400000, total: 20200000 },
  { month: "Aug", fees: 9200000, spread: 14600000, total: 23800000 },
  { month: "Sep", fees: 8600000, spread: 13800000, total: 22400000 },
  { month: "Oct", fees: 10100000, spread: 16200000, total: 26300000 },
  { month: "Nov", fees: 11400000, spread: 18100000, total: 29500000 },
  { month: "Dec", fees: 13200000, spread: 21100000, total: 34300000 },
];

export const alertsData = [
  { id: 1, type: "critical", title: "Large Withdrawal Flagged", message: "WD-0086: ₦2.5M withdrawal by Fatima Bello exceeds daily threshold. Manual review required.", time: "5 min ago", read: false },
  { id: 2, type: "warning", title: "KYC Backlog Growing", message: "37 KYC submissions pending review. Oldest submission is 18 hours old.", time: "12 min ago", read: false },
  { id: 3, type: "info", title: "BTC Price Spike +8%", message: "Bitcoin price increased 8% in the last hour. Monitor for unusual trading activity.", time: "1 hr ago", read: false },
  { id: 4, type: "critical", title: "Failed Transaction Spike", message: "12 failed Paystack transactions in the last 30 minutes. Possible payment gateway issue.", time: "2 hr ago", read: true },
  { id: 5, type: "warning", title: "Suspicious Login Detected", message: "USR-1047 (Uche Nwosu) logged in from a new device in Lagos. Account auto-suspended.", time: "3 hr ago", read: true },
  { id: 6, type: "info", title: "New Milestone: 25,000 Users", message: "CryptoNG has reached 25,000 registered users. Growth rate: +342 users today.", time: "4 hr ago", read: true },
  { id: 7, type: "warning", title: "Low USDT Hot Wallet Balance", message: "TRC20 USDT hot wallet balance is below 500,000 USDT threshold. Consider topping up.", time: "6 hr ago", read: true },
  { id: 8, type: "info", title: "System Maintenance Completed", message: "Scheduled maintenance completed successfully. All services operational.", time: "Yesterday", read: true },
];

export const inquiriesData = [
  {
    id: "INQ-0041",
    user: "Chiamaka Eze",
    userId: "USR-1050",
    email: "chiamaka@gmail.com",
    subject: "Transaction stuck as pending for 3 hours",
    category: "Transaction Issue",
    priority: "high",
    status: "open",
    message: "Hello, I made a buy order for BTC worth ₦500,000 about 3 hours ago and it is still showing as pending. The money has already been deducted from my Paystack wallet but I have not received my BTC. Transaction ID is TXN-00291. Please help me resolve this urgently.",
    proofs: [
      { name: "paystack_receipt.png", type: "image", url: "https://readdy.ai/api/search-image?query=paystack%20payment%20receipt%20screenshot%20mobile%20app%20transaction%20confirmation%20green%20checkmark%20Nigerian%20fintech&width=600&height=400&seq=proof1&orientation=landscape" },
      { name: "transaction_screenshot.png", type: "image", url: "https://readdy.ai/api/search-image?query=crypto%20exchange%20mobile%20app%20transaction%20pending%20status%20screenshot%20dark%20theme&width=600&height=400&seq=proof2&orientation=landscape" }
    ],
    replies: [
      { from: "admin", name: "Support Team", message: "Hi Chiamaka, we have received your complaint and are investigating the transaction TXN-00291. We will update you within 30 minutes.", time: "Today, 10:15 AM" }
    ],
    submitted: "Today, 10:02 AM",
    lastUpdated: "Today, 10:15 AM",
    txRef: "TXN-00291"
  },
  {
    id: "INQ-0040",
    user: "Rotimi Adebayo",
    userId: "USR-1049",
    email: "rotimi@yahoo.com",
    subject: "KYC rejected but documents are valid",
    category: "KYC / Verification",
    priority: "medium",
    status: "open",
    message: "My KYC Tier 2 verification was rejected yesterday but I submitted a valid NIN slip and a clear selfie. I have been using this app for 2 months without issues. Please review my documents again. I need Tier 2 to increase my withdrawal limit.",
    proofs: [
      { name: "nin_slip.jpg", type: "image", url: "https://readdy.ai/api/search-image?query=Nigerian%20NIN%20national%20identity%20card%20document%20verification%20official%20government%20ID%20card&width=600&height=400&seq=proof3&orientation=landscape" }
    ],
    replies: [],
    submitted: "Today, 8:45 AM",
    lastUpdated: "Today, 8:45 AM",
    txRef: null
  },
  {
    id: "INQ-0039",
    user: "Blessing Obi",
    userId: "USR-1048",
    email: "blessing.obi@gmail.com",
    subject: "Sold ETH but Naira not credited to bank",
    category: "Withdrawal",
    priority: "high",
    status: "in_progress",
    message: "I sold 0.23 ETH on April 26 and the transaction shows completed (TXN-00290) but the ₦1,200,000 has not been credited to my GTBank account ending in 5678. It has been over 24 hours. I have attached my bank statement showing no credit.",
    proofs: [
      { name: "bank_statement.pdf", type: "document", url: "" },
      { name: "sell_confirmation.png", type: "image", url: "https://readdy.ai/api/search-image?query=crypto%20sell%20transaction%20confirmation%20success%20screen%20mobile%20app%20dark%20theme%20showing%20ETH%20sold%20naira%20credited&width=600&height=400&seq=proof4&orientation=landscape" }
    ],
    replies: [
      { from: "admin", name: "Finance Team", message: "Hi Blessing, we can confirm the sell transaction TXN-00290 was completed on our end. We have escalated this to our banking partner for investigation. Please allow 2-4 business hours.", time: "Today, 9:00 AM" },
      { from: "user", name: "Blessing Obi", message: "Thank you. Please expedite this as I need the funds urgently.", time: "Today, 9:30 AM" }
    ],
    submitted: "Yesterday, 11:00 PM",
    lastUpdated: "Today, 9:30 AM",
    txRef: "TXN-00290"
  },
  {
    id: "INQ-0038",
    user: "Uche Nwosu",
    userId: "USR-1047",
    email: "uche.n@outlook.com",
    subject: "Account suspended without notice",
    category: "Account",
    priority: "medium",
    status: "resolved",
    message: "My account was suspended and I cannot log in. I did not violate any terms. I have been a loyal customer for 6 months. Please unsuspend my account immediately and explain why this happened.",
    proofs: [],
    replies: [
      { from: "admin", name: "Security Team", message: "Hi Uche, your account was temporarily suspended due to a login from an unrecognized device in Lagos. This is an automated security measure. We have sent a verification email to uche.n@outlook.com to restore access.", time: "Yesterday, 4:00 PM" },
      { from: "user", name: "Uche Nwosu", message: "I received the email and verified. My account is now accessible. Thank you.", time: "Yesterday, 4:45 PM" },
      { from: "admin", name: "Security Team", message: "Great! Your account has been fully restored. We recommend enabling 2FA for extra security. Let us know if you need further assistance.", time: "Yesterday, 5:00 PM" }
    ],
    submitted: "Yesterday, 3:30 PM",
    lastUpdated: "Yesterday, 5:00 PM",
    txRef: null
  },
  {
    id: "INQ-0037",
    user: "Aisha Musa",
    userId: "USR-1046",
    email: "aisha.musa@gmail.com",
    subject: "Wrong amount received after selling USDT",
    category: "Transaction Issue",
    priority: "high",
    status: "open",
    message: "I sold 500 USDT and expected to receive ₦765,000 based on the rate shown at the time of transaction. However I only received ₦748,000. The difference is ₦17,000. Please explain this discrepancy and refund the difference.",
    proofs: [
      { name: "rate_screenshot.png", type: "image", url: "https://readdy.ai/api/search-image?query=crypto%20exchange%20rate%20USDT%20to%20naira%20sell%20screen%20mobile%20app%20showing%20exchange%20rate%20price&width=600&height=400&seq=proof5&orientation=landscape" }
    ],
    replies: [],
    submitted: "Today, 7:20 AM",
    lastUpdated: "Today, 7:20 AM",
    txRef: "TXN-00288"
  },
  {
    id: "INQ-0036",
    user: "Obinna Igwe",
    userId: "USR-1045",
    email: "obinna.igwe@gmail.com",
    subject: "Referral bonus not credited",
    category: "Referral & Bonus",
    priority: "low",
    status: "resolved",
    message: "I referred 3 friends last week using my referral code OBINNA21 and none of them have received their signup bonus. My referral count shows 21 but the bonus for the last 3 was not credited to my account.",
    proofs: [
      { name: "referral_proof.png", type: "image", url: "https://readdy.ai/api/search-image?query=referral%20program%20mobile%20app%20screenshot%20showing%20referral%20code%20friends%20invited%20bonus%20earned&width=600&height=400&seq=proof6&orientation=landscape" }
    ],
    replies: [
      { from: "admin", name: "Support Team", message: "Hi Obinna, we have reviewed your referral account. The 3 referrals were valid and the bonuses have now been manually credited. You should see ₦3,000 added to your wallet. Apologies for the delay.", time: "2 days ago" },
      { from: "user", name: "Obinna Igwe", message: "Confirmed, I can see the credit. Thank you!", time: "2 days ago" }
    ],
    submitted: "3 days ago",
    lastUpdated: "2 days ago",
    txRef: null
  },
  {
    id: "INQ-0035",
    user: "Ngozi Eze",
    userId: "USR-1044",
    email: "ngozi.eze@gmail.com",
    subject: "Cannot add new bank account",
    category: "Account",
    priority: "low",
    status: "in_progress",
    message: "I am trying to add a new Zenith Bank account to my profile but I keep getting an error that says \"Account verification failed\". I have tried 5 times. My BVN is linked and my Tier 2 KYC is verified. Please help.",
    proofs: [
      { name: "error_screenshot.png", type: "image", url: "https://readdy.ai/api/search-image?query=mobile%20app%20error%20message%20account%20verification%20failed%20bank%20account%20adding%20error%20screen%20dark%20theme&width=600&height=400&seq=proof7&orientation=landscape" }
    ],
    replies: [
      { from: "admin", name: "Tech Support", message: "Hi Ngozi, we are aware of an intermittent issue with Zenith Bank account verification. Our engineering team is working on a fix. We will notify you once resolved.", time: "Yesterday, 2:00 PM" }
    ],
    submitted: "Yesterday, 1:00 PM",
    lastUpdated: "Yesterday, 2:00 PM",
    txRef: null
  },
  {
    id: "INQ-0034",
    user: "Seun Adesanya",
    userId: "USR-1041",
    email: "seun.a@gmail.com",
    subject: "Request for transaction history export",
    category: "General",
    priority: "low",
    status: "resolved",
    message: "I need a full export of my transaction history from January 2026 to April 2026 for tax purposes. Please send it to my email seun.a@gmail.com in CSV or PDF format.",
    proofs: [],
    replies: [
      { from: "admin", name: "Support Team", message: "Hi Seun, your transaction history export (Jan–Apr 2026) has been sent to seun.a@gmail.com. Please check your inbox and spam folder.", time: "3 days ago" },
      { from: "user", name: "Seun Adesanya", message: "Got it, thank you!", time: "3 days ago" }
    ],
    submitted: "4 days ago",
    lastUpdated: "3 days ago",
    txRef: null
  },
];

export const recentUsers = [
  { id: "USR-1050", name: "Chiamaka Eze", email: "chiamaka@gmail.com", kyc: "Tier 2", balance: "₦1,240,000", joined: "Today", status: "active" },
  { id: "USR-1049", name: "Rotimi Adebayo", email: "rotimi@yahoo.com", kyc: "Tier 1", balance: "₦85,000", joined: "Today", status: "active" },
  { id: "USR-1048", name: "Blessing Obi", email: "blessing.obi@gmail.com", kyc: "Tier 3", balance: "₦8,400,000", joined: "Yesterday", status: "active" },
  { id: "USR-1047", name: "Uche Nwosu", email: "uche.n@outlook.com", kyc: "Tier 0", balance: "₦0", joined: "Yesterday", status: "suspended" },
  { id: "USR-1046", name: "Aisha Musa", email: "aisha.musa@gmail.com", kyc: "Tier 2", balance: "₦3,100,000", joined: "2 days ago", status: "active" },
];